import { Spinner } from '@shopify/polaris';

const Loading = () => {
    return (
        <div className="min-h-dvh  w-full bg-white flex items-center justify-center z-50">
            <Spinner />
        </div>
    );
};

export default Loading;
